import { DownOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Modal, Select, Spin, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import deliveryService from '@root/modules/Warehouse/Delivery/services/delivery';
import { useParams } from 'react-router-dom';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface DataTrack {
  key: React.Key;
  cmtWarehouse: string;
  status: string;
  trackingNum: string;
  courier: string;
  updatedDate: string;
}

interface Props {
  _getDetailDe: () => void;
  listDetail: any;
}
const { Option } = Select;
const { TextArea } = Input;

const TableDeliExport = ({ _getDetailDe, listDetail }: Props) => {
  const { idDelivery }: any = useParams();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (value: Object) => {
    // setLoading(true);
    try {
      if (form.getFieldValue('status') === 'Request') {
        message.error('Please select status!');
      } else {
        const putHistory = await deliveryService.putDeliHistory(
          value,
          idDelivery
        );
        _getDetailDe();
        setLoading(false);
        message.success('Edit history success!');
      }
    } catch (error: any) {
      setLoading(false);
      message.error('Cant update your history! ');
    }
  };

  useEffect(() => {
    const mapProduct: any = listDetail;

    form.setFieldsValue({
      courier: mapProduct.courier,
      trackingNumber: mapProduct.trackingNumber,
      status: mapProduct.status === 'Request' ? '' : mapProduct.status,
      warehouseComment: mapProduct.warehouseComment
    });
  }, [listDetail]);

  return (
    <Spin spinning={loading}>
      <div className="tableTrack">
        <Form form={form} onFinish={onFinish}>
          <div className="ant-table">
            <div className="ant-table-container">
              <div className="ant-table-content">
                <table style={{ tableLayout: 'auto' }}>
                  <thead className="ant-table-thead">
                    <tr>
                      <th className="ant-table-cell">Update Date</th>
                      <th className="ant-table-cell">Courier</th>
                      <th className="ant-table-cell">Tracking Number</th>
                      <th className="ant-table-cell">Status</th>
                      <th className="ant-table-cell">Comment from Warehouse</th>
                    </tr>
                  </thead>
                  <tbody className="ant-table-tbody">
                    <tr
                      data-row-key="1"
                      className="ant-table-row ant-table-row-level-0"
                    >
                      <td className="ant-table-cell">
                        <Form.Item name="updatedAt">
                          <p>{formatDateTime(listDetail?.updatedAt)}</p>
                        </Form.Item>
                      </td>
                      <td className="ant-table-cell">
                        {' '}
                        <Form.Item
                          name="courier"
                          rules={[
                            {
                              required: true,
                              message: 'Courier can not be empty'
                            }
                          ]}
                        >
                          <Input style={{ resize: 'none' }} />
                        </Form.Item>
                      </td>
                      <td className="ant-table-cell">
                        {' '}
                        <Form.Item
                          name="trackingNumber"
                          rules={[
                            {
                              required: true,
                              message: 'Tracking number can not be empty'
                            },
                            {
                              max: 150,
                              message: 'Character must be less than 150!'
                            }
                          ]}
                        >
                          <Input style={{ resize: 'none' }} />
                        </Form.Item>
                      </td>
                      <td className="ant-table-cell">
                        {' '}
                        <Form.Item
                          style={{ width: '100%' }}
                          name="status"
                          rules={[
                            {
                              required: true,
                              message: 'Please select your status!'
                            }
                          ]}
                        >
                          <Select className="border-input">
                            <Option value="Inprogress">In Progress</Option>
                            <Option value="Complete">Complete</Option>
                          </Select>
                        </Form.Item>
                      </td>
                      <td className="ant-table-cell">
                        {' '}
                        <Form.Item
                          name="warehouseComment"
                          rules={[
                            {
                              required: true,
                              message: 'Comment can not be empty'
                            },
                            {
                              max: 150,
                              message: 'Character must be less than 150!'
                            }
                          ]}
                        >
                          <Input.TextArea
                            // defaultValue={item.warehouseComment}
                            style={{ resize: 'none' }}
                            cols={4}
                            // maxLength={150}
                          />
                        </Form.Item>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="btnDeliver">
            <Button
              type="primary"
              htmlType="submit"
              disabled={listDetail.status === 'Canceled'}
            >
              Save
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default TableDeliExport;
